import React from 'react';
import { Helmet } from 'react-helmet-async';
import commonVariables from '../common_variables.json';

export interface FundOpportunityEOIPrintStylesProps {
  printDraft?: boolean;
  printMode?: boolean;
}

/**
 * Injects the draft watermark and print-mode page styles via react-helmet for the
 * fund opportunity content panel. Extracted from the panel so the large inline
 * <style> blocks don't dominate the panel's render.
 */
export function FundOpportunityEOIPrintStyles({
  printDraft,
  printMode,
}: FundOpportunityEOIPrintStylesProps): JSX.Element {
  return (
    <>
      {printDraft && (
        <Helmet>
          <style>{`
    .fundOppWrapper {
      position: relative; /* Needed for ::before to render */
    }

    .fundOppWrapper::before {
      content: "DRAFT";
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
      font-size: 6rem;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.5);
      text-transform: uppercase;
      pointer-events: none;
      user-select: none;
      z-index: 9999;
      white-space: nowrap;
    }
  `}</style>
        </Helmet>
      )}
      {printMode && (
        <Helmet>
          <style>
            {`
         @page {
            size: A4 ${commonVariables['print-orientation']};
            margin-top: ${commonVariables['print-margin']};
            margin-bottom: ${commonVariables['print-margin']};
        }

@media print {
  @page {
            size: A4 ${commonVariables['print-orientation']};
            margin-top: ${commonVariables['print-margin']};
            margin-bottom: ${commonVariables['print-margin']};
           margin-left: 0 !important;
           margin-right: 0 !important;
  }

  html, body {
    margin: 0 !important;
    padding: 0 !important;
    width: 100%;
    height: 100%;
  }
}

        .hide-print {
          display: none !important;
        }
          html {
            font-size: var(--html-font-size, 12px);
            filter: grayscale(1);
                      }
          html,
          body {
            width: ${commonVariables['print-width']};
            height: ${commonVariables['print-height']};
            margin-left: auto;
            margin-right: auto;

            *:not(.list-item .item-heading, .ellipse, .carousel-item>.item-header) {
            background-color: #ffffff !important;
            }




            .header-container {
            position: relative !important;
            background-color: #ffffff !important;
            width: ${commonVariables['print-width']} !important;
            max-width: ${commonVariables['print-width']} !important;
            right: unset !important;
            }

.header-container > div {
min-height: unset !important;
}

          }


          .app .post-header {
          background-color: #ffffff !important;
          }

.fundopp-stepper .MuiStepConnector-line {
display: none !important;
    }

    .fundopp-stepper .MuiStepIcon-root {
      color: #000 !important;
    }

    .fundopp-stepper .MuiStepIcon-text {
      fill: #FFF !important;
    }

    .fundopp-stepper .MuiStepLabel-label {
      color: #000 !important;
    }
      `}
          </style>
        </Helmet>
      )}
    </>
  );
}
